import JobCarousel from './jobs/JobCarousel';

const PRIMARY = '#fa7c9e';

const handleScrollToSurvey = () => {
  const target = document.getElementById('survey-form-section');
  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

export default function JobsSection() {
  return (
    <section
      id="jobs-section"
      data-track-view="view_jobs_section"
      data-element-name="jobs_section"
      style={{
        padding: '48px 0 56px',
        background: '#fff',
      }}
    >
      <div style={{ maxWidth: '480px', margin: '0 auto' }}>
        {/* Section Title */}
        <div style={{ padding: '0 16px', textAlign: 'center', marginBottom: '24px' }}>
          <p
            style={{
              display: 'inline-block',
              background: PRIMARY,
              color: '#fff',
              fontSize: '12px',
              fontWeight: 700,
              padding: '3px 12px',
              borderRadius: '999px',
              marginBottom: '10px',
            }}
          >
            JOBS
          </p>
          <h2
            style={{
              fontFamily: "'Zen Maru Gothic', sans-serif",
              fontWeight: 900,
              fontSize: '22px',
              color: '#222',
              lineHeight: 1.4,
              marginBottom: '8px',
            }}
          >
            条件が良くなる
            <br />
            求人の一例
          </h2>
          <p style={{ fontSize: '12px', color: '#666', lineHeight: 1.5 }}>
            同じ診療科でも、病院によって条件は大きく変わります
          </p>
        </div>

        {/* Carousel — 端のチラ見えを残すため左パディングのみ */}
        <div style={{ paddingLeft: '16px' }}>
          <JobCarousel />
        </div>

        {/* 注意書き — 必須 */}
        <div
          style={{
            margin: '20px 16px 0',
            padding: '12px 14px',
            background: '#fff8f9',
            border: '1px solid #f3dde3',
            borderRadius: '8px',
            fontSize: '11px',
            lineHeight: 1.7,
            color: '#666',
          }}
        >
          <p style={{ margin: 0 }}>
            ※掲載求人は、ニジ看護転職で取り扱う求人の一例です。
            <br />
            募集状況や条件は時期・施設により変動するため、現在の募集および紹介を保証するものではありません。
            <br />
            最新の求人情報は、ご希望条件をお伺いしたうえで個別に確認・ご案内いたします。
          </p>
        </div>

        {/* CTA */}
        <div style={{ padding: '24px 16px 0' }}>
          <button
            type="button"
            onClick={handleScrollToSurvey}
            data-cta="job-condition"
            data-element-type="cta"
            data-element-name="jobs_to_survey"
            style={{
              width: '100%',
              background: PRIMARY,
              color: '#fff',
              fontWeight: 700,
              fontSize: '16px',
              padding: '16px',
              border: 'none',
              borderRadius: '10px',
              boxShadow: '0 4px 12px rgba(250, 124, 158, 0.35)',
              cursor: 'pointer',
              fontFamily: "'Zen Maru Gothic', sans-serif",
            }}
          >
            この条件で相談する
          </button>
          <p
            style={{
              fontSize: '11px',
              color: '#888',
              textAlign: 'center',
              marginTop: '8px',
            }}
          >
            ※相談・登録は完全無料です
          </p>
        </div>
      </div>
    </section>
  );
}
